import Teasers from "./Teasers";
import Pagination from "./../Pagination/Pagination";

export default () => {
  const teasers = Teasers();
  const parentFiltersInit = teasers.filtersInit;
  const parentToggleTag = teasers.toggleTag;
  const parentToggleCategory = teasers.toggleCategory;
  const parentResetFilters = teasers.resetFilters;
  const pagination = Pagination();
  const parentSetPage = pagination.setPage;

  return Object.assign(teasers, pagination, {
    filtersInit(items) {
      this.historyRestoreState();

      this.paginationInit(items);
      parentFiltersInit.call(this, items);

      window.onpopstate = (event) => {
        if (this.historyRestoreState()) {
          this.filterItems();
          this.setPage(this.pagination.page || 1);
        } else {
          parentResetFilters.call(this);
          this.filterItems();
          this.setPage(1);
        }
      };
    },
    resetFilters() {
      parentResetFilters.call(this);
      this.filterItems();
      this.setPage(1);
      this.historyPushState();
    },
    filterItems() {
      this.itemsFiltered = this.items.filter((item) => {
        const { tags, subtitle: category } = item;
        const visibleByTags =
          this.selectedTags.length === 0 ||
          tags
            .map((tag) => ({ name: tag.title }))
            .some((tag) => this.isSelectedTag(tag));
        const visibleByCategories =
          this.selectedCategories.length === 0 ||
          this.isSelectedCategory(category);
        return visibleByTags && visibleByCategories;
      });
    },

    teaserVisibility(teaser) {
      return {
        ["x-show"]() {
          return this.itemsFilteredAndPaginated.some(
            (item) => item.identifier === teaser.identifier
          );
        },
      };
    },

    toggleTag(tag) {
      parentToggleTag.call(this, tag);

      this.filterItems();
      this.setPage(1);
      this.historyPushState();
    },

    toggleCategory(category) {
      parentToggleCategory.call(this, category);

      this.filterItems();
      this.setPage(1);
      this.historyPushState();
    },

    historyPushState() {
      const state = {
        pagination: this.pagination.page,
        selectedTags: [...this.selectedTags.map((t) => t.name)],
        selectedCategories: [...this.selectedCategories],
      };
      delete state.pagination.list;
      window.history.pushState(state, "");
    },

    historyRestoreState() {
      if (
        !window.history.state ||
        !window.history.state.pagination ||
        !window.history.state.selectedTags ||
        !window.history.state.selectedCategories
      ) {
        return false;
      }

      this.pagination.page = window.history.state.pagination;
      this.selectedCategories = window.history.state.selectedCategories;
      this.selectedTags = this.tags.filter((t) =>
        window.history.state.selectedTags.includes(t.name)
      );

      return true;
    },

    paginationGoToPage(page) {
      return {
        ["@click"]() {
          this.setPage(page);
          this.historyPushState();
        },
        [":class"]() {
          return parseInt(page) === this.pagination.page
            ? "active"
            : "cursor-pointer";
        },
      };
    },
    paginationGoToPreviousPage() {
      return {
        ["@click"]() {
          this.setPage(this.pagination.page - 1);
          this.historyPushState();
        },
        [":class"]() {
          return this.pagination.page === 1 ? "" : "cursor-pointer";
        },
      };
    },

    paginationGoToNextPage() {
      return {
        ["@click"]() {
          this.setPage(this.pagination.page + 1);
          this.historyPushState();
        },
        [":class"]() {
          return this.pagination.page === this.pagination.maxPage
            ? ""
            : "cursor-pointer";
        },
      };
    },
    paginationShowMoreButton() {
      return {
        ["@click"]() {
          this.setPage(this.pagination.page + 1);
          this.historyPushState();
        },
      };
    },
  });
};
